// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorSummary, IErrorSummary } from "./CoreApi.Data.ErrorSummary.gen";

export interface IDeviceErrorPaginatedResult {
	data: IErrorSummary[] | undefined;

	totalOccurrences: number;

	totalDevices: number;

	latestFirmware: string | undefined;

	totalCount: number;

	page: number;

	pageSize: number;

	totalPages: number;

	$type?: string | undefined;
}
export class DeviceErrorPaginatedResult {
	constructor(data?: IDeviceErrorPaginatedResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new ErrorSummary(d)) : [];
	}

	data: ErrorSummary[] | undefined = [];

	totalOccurrences: number = 0;

	totalDevices: number = 0;

	latestFirmware: string | undefined;

	totalCount: number = 0;

	page: number = 0;

	pageSize: number = 0;

	totalPages: number = 0;

	static $type: string = "CoreApi.Models.Pagination.DeviceErrorPaginatedResult, ";
	$type?: string | undefined = DeviceErrorPaginatedResult.$type;
}

